export const setLoginState = (username = '', password = '') => dispatch => {
    dispatch({
        type: 'SET_LOGIN_STATE',
        username,
        password
    });
};

